/* eslint-disable no-unused-expressions */
import { getBalance } from '../../../../../api/atlas/balance'

import './styles.css'

// ** Third Party Components
import { useState, useEffect } from 'react'
import { isUserLoggedIn } from '@utils'

const NavbarBalance = props => {
    const [balance, setBalance] = useState(null);

    useEffect(async () =>  {
      if(isUserLoggedIn() !== null) {
        const email = JSON.parse(localStorage.getItem('userData')).email

        const response = await getBalance(email)
          .then((res) => res[0] === 200 ? res[1] : null)
        
        response ? setBalance(response.data.balance) : null
      }
    }, [])

    return (
      balance ? 
      <div>
        <p className="balance-text">
          {`Saldo: R$${balance.toFixed(2)}`}
        </p>
      </div> :
      null
    )
}

export default NavbarBalance

